import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });
if (window.self !== window.top && window.name === "cp-health-check") api.defaults.headers.common["X-Health-Check"] = "1";

export const photoUrl = (path) => {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  return `${API}/files/${path}`;
};

export const showsFlyer = (l) => Boolean(l?.lf_type && l.status === "active" && !l.reunited_at);
export const flyerUrl = (l, { fmt = "png", lang = "en", w = 0, v = "" } = {}) =>
  `${API}/listings/${l.id}/flyer.${fmt}?lang=${lang}${w ? `&w=${w}` : ""}${v ? `&v=${encodeURIComponent(v)}` : ""}`;

const slugify = (t, fallback) => (t || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
  .replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 48).replace(/-+$/, "") || fallback;
export const adShareUrl = (l, lang = "en") => `${API}/a/${slugify(l.title, "ad")}-${l.id.slice(0, 8)}${lang === "fr" ? "?lang=fr" : ""}`;
export const sellerShareUrl = (u) => `${API}/u/${slugify(u.username || u.name, "seller")}-${u.user_id.replace(/^user_/, "").slice(0, 8)}`;

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x.msg || JSON.stringify(x)).replace(/^Value error, /, "")).join(" ");
  return e?.message || "Something went wrong";
};

// Stable per-browser id used to dedupe marketing-banner impressions (so refreshes don't inflate reach).
export const viewerId = () => {
  try {
    let id = localStorage.getItem("cp_viewer");
    if (!id) {
      id = (crypto?.randomUUID?.() || `v${Date.now()}${Math.random().toString(36).slice(2)}`);
      localStorage.setItem("cp_viewer", id);
    }
    return id;
  } catch {
    return "";
  }
};
